import React, { useEffect, useState } from 'react';
import '../../MainDash/Alerts/AlertInfoPage.css';
import '../../MainDash/NewHome.css';
import { IconButton, Button } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AlertService from '../../../services/AlertService';
import { useHistory } from 'react-router-dom';
import { getUserId } from '../../../utils/AuthUtilities';
import Dropdown from "./Dropdown";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField'; 
import AlertModal from '../../MainDash/Alerts/AlertModal';

const AnalysisPage = ({ title, filters }) => {
    const history = useHistory();
    const user_id = getUserId();
    const [user, setUser] = useState(null);
    const [dataList, setDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [buildings, setBuildings] = useState([]);
    const [suites, setSuites] = useState([]);
    const [selectedBuilding, setSelectedBuilding] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");
    const [email, setEmail] = useState(user?.email || '');
    const [isReportEmailModalOpen, setIsReportEmailModalOpen] = useState(false);


    // Utility function to fetch details based on type
    const fetchDetails = async (id, title) => {
        console.log('type: ' + title);
        try {
            if (title === 'Tenant') {
                const tenantData = await AlertService.getTenantById(id);
                return tenantData;
            } else if (title === 'Building') {
                const buildingData = await AlertService.getBuildingById(id);
                return buildingData;
            }
        } catch (error) {
            console.error(`Failed to fetch ${title} details:`, error);
            return null;
        }
    };

    // Utility function to fetch building info
    const fetchBuildings = async (ids) => {
        try {
            const buildings = await Promise.all(ids.map(id => AlertService.getBuildingById(id)));
            return buildings; 
        } catch (error) {
            console.error('Failed to fetch building details:', error);
            return [];
        }
    };
    
    // Utility function to fetch suites
    const fetchSuites = async (ids) => {
        try {
            const suites = await Promise.all(ids.map(id => AlertService.getSuiteById(id)));
            return suites; 
        } catch (error) {
            console.error('Failed to fetch building details:', error);
            return [];
        }
    };

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await AlertService.getUserById(user_id);
                setUser(userData);
                setEmail(userData.email);
                console.log(userData);
                if (userData.buildings) {
                    setBuildings(await fetchBuildings(userData.buildings));
                }
                setIsLoading(false);
            } catch (error) {
                console.error('Failed to fetch user:', error);
                setIsLoading(false);
            }
        };

        fetchUser();
    }, [user_id, title]);

    useEffect(() => {
        if (isSubmitting) {
            setIsModalOpen(true)
        }
    }, [isSubmitting])

    if (isLoading) {
        return (
            <div className='loader-container'>
                <div className="loader"></div>
            </div>
        );
    }

    const handleFilterChange = (filterName, value) => {
        setSelectedFilters(prev => ({
            ...prev,
            [filterName]: value,
        }));

        // If a building is selected, fetch suites
        if (filterName === "Building") {
            fetchSuites(value);
        }
    };

    const handleBuildingSelect = (buildingAddress) => {
        const selected = buildings.find(building => building.address === buildingAddress);
        setSelectedBuilding(selected);
   
        if (selected && selected.suites) {
            fetchSuites(selected.suites); 
        } else {
            setSuites([]); 
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsReportEmailModalOpen(true); // open email entry modal
    };    

    return (
    <>
        <div className="AlertPage">
            <div className="alerts-section">
                <div className="alerts-header">
                    <div className="title-container">
                        <IconButton onClick={() => history.push('/Home')}>
                            <ArrowBackIosNewIcon
                                className="z-0"
                                style={{ color: 'rgb(14, 81, 46)' }}
                            />
                        </IconButton>
                        <h2>{title}</h2>
                        <div className="placeholder" style={{ width: '40px', backgroundColor: 'transparent' }}></div>
                    </div>
                </div>

                <div className="analysis-grid">
                    <Dropdown 
                        title="Building" 
                        contents={buildings.map(building => building.address)} 
                        onSelect={handleBuildingSelect}
                    />
                    <Dropdown 
                        title="Suite" 
                        contents={suites.map(suite => suite.number)} 
                        onSelect={(content) => console.log('Selected:', content)}
                        disabled={!selectedBuilding} 
                    />
                </div>
                <div className="analysis-filters">
                    <div className='filters-title'>Filters:</div>
                    {/* Render Filters */}
                    <div className="filters-container">
                        {/* Dropdowns Container */}
                        <div className="dropdown-filters">
                            {filters.filter((filter) => filter.type === "dropdown").map((filter, index) => (
                                <Dropdown
                                key={index}
                                title={filter.name}
                                contents={filter.options}
                                onSelect={(value) => handleFilterChange(filter.name, value)}
                              />
                            ))}
                        </div>

                        {/* Buttons Container */}
                        <div className="button-filters">
                            {filters.filter((filter) => filter.type === "button").map((filter, index) => (
                                <Button
                                    key={index}
                                    variant={selectedFilters[filter.name] ? "contained" : "outlined"}
                                    onClick={() =>
                                        handleFilterChange(filter.name, !selectedFilters[filter.name])
                                    }
                                    
                                    sx={{
                                        backgroundColor: selectedFilters[filter.name]
                                            ? '#CCDAC5' // Active color when selected
                                            : 'initial', // Default color when not selected
                                        '&:hover': {
                                            backgroundColor: selectedFilters[filter.name]
                                                ? '#CCDAC5' // Hover color when active (slightly darker)
                                                : 'white', // Default hover color,
                                            borderColor: selectedFilters[filter.name] ? '#CCDAC5' : '#CCDAC5',
                                        },
                                        color: selectedFilters[filter.name] ? 'initial' : 'initial', // Text color when active
                                        borderColor: selectedFilters[filter.name] ? '#CCDAC5' : '#CCDAC5', // Border color when active
                                    }}
                                >
                                    {filter.name}
                                </Button>
                            ))}
                        </div>

                        {/* Datepickers Container */}
                        <div className="date-filters">
                            {filters.filter((filter) => filter.type === "date").map((filter, index) => (
                                <LocalizationProvider dateAdapter={AdapterDayjs} key={index}>
                                    <DatePicker
                                        label={filter.name}
                                        value={selectedFilters[filter.name] ? dayjs(selectedFilters[filter.name]) : null}
                                        onChange={(newValue) => handleFilterChange(filter.name, newValue)}
                                        renderInput={(params) => 
                                            <TextField 
                                                {...params} 
                                                sx={{
                                                    width: '150px', 
                                                    zIndex: 0,
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: 2, 
                                                    },
                                                }} 
                                            />
                                        }
                                        
                                    />
                                </LocalizationProvider> 
                            ))}
                        </div>
                    </div>

                    <div className='alert-button-container'>
                            <button className='alert-info-button' 
                                onClick={handleSubmit}
                                style={{padding: '0.5em 0.85em', fontSize: '16px', margin: '20px'}}>
                                Submit
                            </button>
                    </div>
                </div>
                

            </div>
        </div>
        <AlertModal
            isModalOpen={isReportEmailModalOpen}
            closeModal={() => setIsReportEmailModalOpen(false)}
            confirmModal={() => {}}
            handleOptionClick={() => {}}
            height="260px"
            style={{ zIndex: 1300 }}
            title="Report Will Be Sent To:"
            options={[]}
        >
            <div style={{ marginBottom: '1em' }}>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                        width: '100%',
                        padding: '0.5em',
                        marginTop: '0.5em',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                    }}
                />
                <p style={{ marginTop: '0.5em', fontSize: '0.9em', color: '#555' }}>
                    Enter a new email if the report needs to be sent elsewhere.
                </p>
            </div>
            <button
                className="modal-button alert-confirm"
                onClick={() => {
                    setIsReportEmailModalOpen(false);
                    setIsModalOpen(true); // trigger the 'Submitted' modal
                }}
            >
                Submit
            </button>
        </AlertModal>

        <AlertModal
            isModalOpen={isModalOpen}
            closeModal={() => setIsModalOpen(false)}
            confirmModal={() => history.push('/Home')}
            handleOptionClick={() => { }}
            height="200px"
            style={{zIndex: 1300}}
            title="Submitted!"
            options={[]}
        >
            <button className="modal-button alert-confirm" onClick={() => history.push('/Home')}>Return to Home</button>
        </AlertModal>

    </>
    );
};

export default AnalysisPage;
